import OptionsConfiguration from './OptionsConfiguration'

export default OptionsConfiguration
